<template>
  <div class="wrapper">
    <parallax class="page-header header-filter" style="height: 130px">
    </parallax>
    <div class="main main-raised">
      <div class="section section-basic">
        <div class="container" style="min-height: 500px">
          <div class="contentBox">
            <el-card class="rightContent">
              <h3>
                <span>{{ $t("classDetail.detail") }}</span>
                <el-button @click="goBack()" style="float: right">
                  {{ $t("button.back") }}
                </el-button>
              </h3>
              <el-divider></el-divider>
              <el-form
                :model="classDetail"
                ref="classDetail"
                label-width="100px"
              >
                <el-form-item :label="$t('classDetail.title')" prop="name">
                  {{ classDetail.name }}
                </el-form-item>
                <el-form-item :label="$t('classDetail.id')" prop="id">
                  {{ classDetail.id }}
                </el-form-item>
                <el-form-item
                  :label="$t('classDetail.size')"
                  prop="workerCount"
                >
                  {{ classDetail.workerCount }}
                </el-form-item>
              </el-form>
            </el-card>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Leftbar from "../../components/newComponent/Leftbar";

import { classDetailGet } from "../../api/class";

export default {
  components: {
    Leftbar,
  },
  name: "classDetail",
  bodyClass: "index-page",
  props: {},
  data() {
    return {
      classDetail: {},
      classId: 0,
      loading: false,
      classMemberList: [],
      totalPage: 1,
      currentPage: 1,
      totalMember: 0,
      colors: ["#99A9BF", "#F7BA2A", "#FF9900"],
    };
  },
  mounted() {
    this.classId = this.$route.params.id;
    this.loadClassDetail();
  },
  methods: {
    loadClassDetail() {
      classDetailGet(this.classId, this.currentPage).then((res) => {
        if (res.id) {
          this.classDetail = res;
        }
      });
    },
    goBack() {
      this.$router.go(-1);
    },
  },
  computed: {
    signupImage() {
      return {
        backgroundImage: `url(${this.signup})`,
      };
    },
  },
  watch: {
    currentPage() {
      this.loadClassMember();
    },
  },
};
</script>

<style lang="scss">
.section-download {
  .md-button + .md-button {
    margin-left: 5px;
  }
}

@media all and (min-width: 991px) {
  .btn-container {
    display: flex;
  }
}
</style>

<style scoped>
.demo-table-expand {
  font-size: 0;
  margin: 10px 0px 10px 60px;
}
.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}
.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
.test {
  border: 1px solid black;
}
</style>

<style>
.copyIcon {
  cursor: pointer;
}
</style>
